import styled from 'styled-components';
import { FlexCenterBoth } from 'components/primitives/flex';
import CloseButton from 'components/ui/CloseButton/CloseButton';
import Panel from 'components/ui/Panel/Panel';
import { FC, useState } from 'react';

interface Props {
  ToggleComponent: FC<any>;
  PanelContents: FC<any>;
  isOpenControlled?: boolean;
  setIsOpenControlled: (value: boolean) => void;
  controlled?: boolean;
  panelWidth?: number | 'auto';
  panelHeight?: number | 'auto';
  panelPlacement?: 'top' | 'bottom';
}

const PopOver = ({
  ToggleComponent,
  PanelContents,
  setIsOpenControlled,
  isOpenControlled,
  controlled = false,
  panelWidth = 'auto',
  panelHeight = 'auto',
  panelPlacement = 'top',
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    if (controlled) {
      setIsOpenControlled(!isOpenControlled);
    } else {
      setIsOpen(!isOpen);
    }
  };

  return (
    <PopOverWrapper>
      <ToggleComponent
        onClick={(e) => {
          e.preventDefault();
          toggleOpen();
        }}
      />

      {(controlled && isOpenControlled) || isOpen ? (
        <PanelOuter
          style={{
            width: panelWidth,
            height: panelHeight,
            position: 'absolute',
            bottom: panelPlacement === 'top' ? '110%' : null,
            top: panelPlacement === 'bottom' ? '110%' : null,
            zIndex: 100,
          }}
        >
          <Panel>
            <PopOverClose>
              <CloseButton
                onClick={(e) => {
                  e.preventDefault();
                  toggleOpen();
                }}
              />
            </PopOverClose>

            <PanelContents />
          </Panel>
        </PanelOuter>
      ) : null}
    </PopOverWrapper>
  );
};

export default PopOver;

const PopOverWrapper = styled.div`
  position: relative;
`;

const PanelOuter = styled.div``;

const PopOverClose = styled(FlexCenterBoth)`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 99;
  cursor: pointer;
  svg {
    width: 12px;
    path {
      stroke: #17233c;
    }
  }
`;
